/**
 * API 服务类
 * 提供类型安全的 API 调用方法
 */

import { httpClient } from '@/utils/http'

export class BackpackAPI {
    /**
     * 获取背包列表
     */
    static async getBackpackList(data: any): Promise<any> {
        return httpClient.post<any>('/unlockAlbumList', data)
    }
}